let temeId = localStorage.getItem("temeId"); //主题颜色ID
let isLogin = localStorage.getItem("isLogin"); //是否填写
let quesType = "1"; //0：问题登记，1：更多资料，2：联系我们，3.体验
let quesTypeName = ""; //0：问题登记，1：更多资料，2：联系我们，3.体验
let indexShow = localStorage.getItem("indexShow"); //导航下标全局变量
//设置主题色  灰色
let grey = function(type) {
  if (temeId == "2") {
    $("html").css({
      "-webkit-filter": "grayscale(100%)",
      "-moz-filter": "grayscale(100%)",
      "-ms-filter": "grayscale(100%)",
      "-o-filter": "grayscale(100%)",
      // ie滤镜
      filter: "progid:DXImageTransform.Microsoft.BasicImage(grayscale=1)",
      // ie6 等低版本浏览器不需要加滤镜
      _filter: "none"
    });
  } else {
    $("html").css({
      "-webkit-filter": "none",
      _filter: "none"
    });
  }
};
export default {
  temeId,
  isLogin,
  quesType,
  quesTypeName,
  indexShow,
  grey
};



// WEBPACK FOOTER //
// ./src/global/globalData.js